// components/LightboxImage.jsx
import { useEffect } from 'react';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

const LightboxImage = ({ src, alt = 'Image', group = 'gallery', zoom = true, className = '' }) => {
    useEffect(() => {
        const lightbox = GLightbox({
            selector: `.glightbox-${group}`,
            zoomable: zoom,
            loop: true,
            effect: 'zoom', // enables zoom transition
        });

        return () => {
            lightbox.destroy();
        };
    }, [src, group, zoom]);

    return (
        <a
            href={src}
            className={`glightbox-${group}`}
            data-gallery={group}
            data-type="image"
        >
            <img
                src={src}
                alt={alt}
                className={`cursor-zoom-in transition duration-300 rounded-xl hover:opacity-90 ${className}`}
            />
        </a>
    );
};

export default LightboxImage;
